<template>
  <div class="hidden" v-for="group in effectGroups" :key="group.name">
    <div v-for="effect in group.effects" :key="effect.thumbnail">
      <img :src="`https://static.serato.com/visualizer/images/${effect.thumbnail}-small-1x.jpg`">
      <img :src="`https://static.serato.com/visualizer/images/${effect.thumbnail}-small-2x.jpg`">
      <img :src="`https://static.serato.com/visualizer/images/${effect.thumbnail}-small-1x.webp`">
      <img :src="`https://static.serato.com/visualizer/images/${effect.thumbnail}-small-2x.webp`">
    </div>
  </div>
</template>

<script setup lang="ts">
import { effectGroups } from '@/static/effectName'

</script>

<style lang="scss">
.hidden {
  display: none;
}
</style>